import React from 'react';
import { bool, func, oneOfType, arrayOf, node, string } from 'prop-types';

// devExtreme
import Popup from 'devextreme-react/popup';

export const DataPopup = ({
  visibiblity,
  setVisibility,
  showCloseButton,
  customCloseBtnHandler,
  title,
  children,
  currentRowData,
  ...rest
}) => {
  const onHiding = (e) => {
    if (customCloseBtnHandler) {
      e.cancel = true;

      customCloseBtnHandler(e);
    } else {
      setVisibility(false);
    }
  };

  return (
    <Popup
      title={!title ? '' : `${title} ID: ${currentRowData?.Id}`}
      visible={visibiblity}
      onHiding={onHiding}
      showCloseButton={showCloseButton}
      {...rest}
    >
      <div style={{ height: '100%' }}>{visibiblity && <>{children}</>}</div>
    </Popup>
  );
};

DataPopup.propTypes = {
  visibiblity: bool.isRequired,
  setVisibility: func.isRequired,
  customCloseBtnHandler: func,
  showCloseButton: bool,
  title: string,
  children: oneOfType([arrayOf(node), node])
};
